// Header.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaSun, FaMoon } from 'react-icons/fa';

function Header({ toggleTheme, theme }) {
    return (
        <header className="bg-gradient-to-r from-blue-50 to-blue-400 dark:from-gray-900 dark:to-gray-800 dark:bg-gradient-to-r p-5 dark:text-yellow-300 flex justify-between items-center transition-colors duration-300 shadow-md">
            <div className="text-2xl font-semibold text-blue-700 dark:text-yellow-300">
                <h1>Personal Website</h1>
            </div>
            <nav>
                <ul className="flex space-x-6 text-lg font-semibold">
                    <li><Link to="/" className="text-gray-800 hover:text-blue-600 dark:text-white dark:hover:text-yellow-300">Home</Link></li>
                    <li><Link to="/portfolio" className="text-gray-800 hover:text-blue-600 dark:text-white dark:hover:text-yellow-300">Portfolio</Link></li>
                    <li><Link to="/projects" className="text-gray-800 hover:text-blue-600 dark:text-white dark:hover:text-yellow-300">Projects</Link></li>
                    <li><Link to="/contact" className="text-gray-800 hover:text-blue-600 dark:text-white dark:hover:text-yellow-300">Contact</Link></li>
                </ul>
            </nav>
            <button
                onClick={toggleTheme}
                className="p-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 dark:bg-yellow-400 dark:text-black flex items-center transition-colors duration-300"
            >
                {theme === 'day' ? <FaMoon className="mr-2" /> : <FaSun className="mr-2" />}
                {theme === 'day' ? 'Night Mode' : 'Day Mode'}
            </button>
        </header>
    );
}

export default Header;
